import coprintIcon from "../assets/brand/coprint-icon.png";

export function Logo() {
  return (
    <div className="pa-logo" aria-label="Coprint">
      <img className="pa-logo-mark" src={coprintIcon} alt="" aria-hidden="true" />
      <span>Coprint</span>
    </div>
  );
}
